var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card-actions",
    {
      staticClass: "d-flex flex-wrap justify-center grey lighten-2 max-width",
      class: _vm.animated ? "animated slideInUp" : "",
      staticStyle: { height: "80px" },
      attrs: { align: "end" },
    },
    [
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.closeBtn,
              expression: "closeBtn",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: { rounded: "", color: "primary", small: "" },
          on: { click: _vm.toClose },
        },
        [_vm._v(_vm._s(_vm.$t("label_shut_down")))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.cancelBtn,
              expression: "cancelBtn",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: { text: "", rounded: "", color: "primary", small: "" },
          on: { click: _vm.toCancel },
        },
        [_vm._v(_vm._s(_vm.$t("label_essweb_form_tools_cancelBtnLabel")))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.preStep,
              expression: "preStep",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: { text: "", rounded: "", color: "primary", small: "" },
          on: { click: _vm.toPre },
        },
        [_vm._v(_vm._s(_vm.$t("label_essweb_form_tools_previousBtnLabel")))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.newBtn,
              expression: "newBtn",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: {
            rounded: "",
            color: "primary",
            small: "",
            loading: _vm.loading || _vm.onLoading,
            disabled: _vm.loading || _vm.onLoading,
          },
          on: { click: _vm.toNew },
        },
        [_vm._v(_vm._s(_vm.$t(_vm.newText)))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.saveBtn,
              expression: "saveBtn",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: {
            rounded: "",
            color: "primary",
            disabled: _vm.loading || _vm.canOkBtn || _vm.onLoading,
            small: "",
            loading: _vm.loading || _vm.onLoading,
          },
          on: { click: _vm.toSave },
        },
        [_vm._v(_vm._s(_vm.$t(_vm.saveText)))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.step,
              expression: "step",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: { rounded: "", color: "primary", small: "" },
          on: { click: _vm.toNext },
        },
        [_vm._v(_vm._s(_vm.$t("label_essweb_form_tools_nextBtnLabel")))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.okBtn,
              expression: "okBtn",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: {
            rounded: "",
            color: "primary",
            small: "",
            loading: _vm.loading || _vm.onLoading,
            disabled: _vm.loading || _vm.canOkBtn || _vm.onLoading,
          },
          on: { click: _vm.toOk },
        },
        [_vm._v(_vm._s(_vm.$t("label_essweb_form_tools_oKBtnLabel")))]
      ),
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.submitBtn,
              expression: "submitBtn",
            },
          ],
          staticClass: "pl-7 pr-7 text-button",
          staticStyle: { height: "32px" },
          attrs: {
            rounded: "",
            color: "primary",
            small: "",
            disabled: _vm.loading || _vm.canSubmitBtn || _vm.onLoading,
            loading: _vm.loading || _vm.onLoading,
          },
          on: { click: _vm.toSubmit },
        },
        [_vm._v(_vm._s(_vm.$t("label_essweb_form_tools_submitBtnLabel")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }